import ResumeInfoUI from "../../ui-elements/resume-info-ui";
import { BookMarkData } from "../../lib/bookmarking-manager";
import { ItemNode } from "../../lib/components/grid/ItemNode";
import { AppData, Log, Utils, Lightning, Registry } from "@lightningjs/sdk";
import { fetchData, postLikeDislikeUrl } from "../../lib/models/data-service";
import Router from "@lightningjs/sdk/src/Router";
import { AppSetup } from "../../lib/app-setup";
import { Helper } from "../../lib/helper";
import LableButton from "../../ui-elements/lable-button";
import ResumeButton from "../../ui-elements/resume-button";
import { Logger } from "../../lib/logger";
import GridViewModel from "../../lib/components/grid/grid-view-model";
import { TextBox } from "@lightningjs/ui-components";
import { KeyCodes } from "../../lib/key-codes";
import { AppApiConfig } from "../../lib/app-api-config";
import ResumeLabelButton from "../../ui-elements/resume-label-button";
import BackBarUI from "../../ui-elements/back-bar";


export interface BookmarkWidgetTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class BookmarkWidget
    extends Lightning.Component<BookmarkWidgetTemplateSpec>
    implements Lightning.Component<BookmarkWidgetTemplateSpec>
{

    _vodInfo!: ItemNode; //parent grid show thumbnail data
    _bdata!: ItemNode[]
    page!: any
    isBookmarApiLoaded = false
    isDeeplink = false //if is deeplink do not load the show again as it is already loaded in grid.
    resumeTime = '0'
    _index = 1;
    autoPlayTimerId: any;
    count = 0;
    autoPlayTime = 10;
    resumeType = 'bookmark' // 'bookmark' or resume'
    isActivated = false
    textfocuscolor: any

    static override _template(): Lightning.Component.Template<BookmarkWidgetTemplateSpec> {
        return {
            color: 0xff000000,
            rect: true,
            w: 1920,
            h: 1080,
            alpha: 0,
            ItemInfo: {
                w: (w: any) => w,
                h: (h: any) => h,
                type: ResumeInfoUI,
                alpha: 0,
                zIndex: 61,
                collision:true,
                background: './images/info_bg-236.png',
            },
            BackBar: {
                x: 0,
                y: 0,
                type: BackBarUI,
                zIndex: 65,
                collision: true,
            },
            ButtonsWrapper: {
                x: 112,
                y: (h: any) => h - 380,
                Buttons: {
                    collision:true,
                    flex: { direction: "row" },
                },
            },
            AutoPlayText: {
                x: (w: any) => 165,
                y: (h: any) => h - 180,
                flex: { direction: 'row' },
                type:TextBox,
                content: '',
                zIndex: 63,
                style:{
                    textStyle: {
                        fontFace: Helper.getFontFamily('Black'),
                        letterSpacing: 0.82,
                        fontSize: 36,
                    }
                }
            },
            visible: false
        }
    }

    override _active() {
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        this.textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
    }

    $setbdata(vodInfo: ItemNode, isDeeplink = false) {
        this._vodInfo = vodInfo
        this.isDeeplink = isDeeplink
        if (this._vodInfo.feed_type == 'video') {
            this.resumeType = 'video'
            Log.info('Resume Vod Info set,', this._vodInfo)
        } else {
            this.resumeType = 'bookmark'
            Log.info('Bookmark Vod Info set,', this._vodInfo)
            //this._handleBookmarkData()
        }
    }

    async _handleBookmarkData() {
        this.isBookmarApiLoaded = false
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        let bdata = await app?.bookmarkingManager.checkBookmarkAndLoadShows(this._vodInfo)
        if (bdata && bdata[1]?.season !== null && bdata[1]?.episode !== null && bdata[1]?.season !== '' && bdata[1]?.episode !== '') {
            this._bdata = bdata
            Log.info('Bookmark bdata,', bdata)
            this.isBookmarApiLoaded = true
            this.page.widgets.loadingscreen.showLoadingScreen(false)
            this._update()
        } else {
            if (this.isDeeplink) {
                const vodInfo: ItemNode = app?.navigation.getCurrentGrid().getFocusedItem();
                Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
            } else {
                Router.navigate(`mlp-grid-screen/${this._vodInfo.id}`, false)
            }
        }
    }

    _getActionKey() {
        let vodInfo = this.resumeType == 'video' ? this._vodInfo : this._bdata[0]
        if (vodInfo) {
            return `${vodInfo.node_id}_${this.resumeTime}`
        }
        return ''
    }

    _updateAutoplayTimerText(sec) {
        const timerText = `Auto playing video in ... ${sec} seconds`
        this.tag('AutoPlayText').content = [
            'Auto playing video in ...',
            {   text: ` ${sec} `,
                style: { textColor: this.textfocuscolor }
            },
            'seconds'
        ]
    }

    _update() {
        let vodInfo = this.resumeType == 'video' ? this._vodInfo : this._bdata[0]
        this.patch({
            ItemInfo: {
                item: vodInfo,
                alpha: 1
            },
        });
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        const enableLikeDislike = appApiConfig?.appConfig?.enableLikeDislike === true;
        const buttons = Helper.resumeScreenButtons
        const buttonsToAdd: any[] = []
        buttons.map((button: any, index) => {
            if (!enableLikeDislike && (button.action === '$like' || button.action === '$love' || button.action === '$dislike')) {
                return;
            }
            if (this.resumeType == 'video') {
                this.isBookmarApiLoaded = true
                if (button.src) {
                     // Icon button (Play from beginning, Like, etc)
                     buttonsToAdd.push({
                        type: ResumeButton,
                        action: button.action,
                        label: button.label,
                        iconSrc: Utils.asset(button.src),
                        focusedSrc: Utils.asset(button.focusedSrc),
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height,
                        collision: true,
                        zIndex: 62,
                    })
                } else {
                    // Standard Label Button (Resume)
                    buttonsToAdd.push({
                        type: ResumeLabelButton,
                        action: button.action,
                        label: button.label,
                        collision: true,
                        zIndex: 62,
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height || "",
                    })
                }
            } else {
                const seasonStr = (this._bdata[1]?.season.length == 1 ? '0' + this._bdata[1]?.season : this._bdata[1]?.season)
                const episodeStr = (this._bdata[1]?.episode.length == 1 ? '0' + this._bdata[1]?.episode : this._bdata[1]?.episode)
                if (button.src) {
                     buttonsToAdd.push({
                        type: ResumeButton,
                        action: button.action,
                        label: button.label,
                        iconSrc: Utils.asset(button.src),
                        focusedSrc: Utils.asset(button.focusedSrc),
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height,
                        collision: true,
                        zIndex: 62
                    })
                } else {
                     buttonsToAdd.push({
                        type: ResumeLabelButton,
                        action: button.action,
                        label: (button.action == '$resume' ? `${button.label} S${seasonStr}E${episodeStr}` : button.label),
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height || "",
                        collision: true,
                        zIndex: 62
                    })
                }
            }
        });
        this.tag("ButtonsWrapper.Buttons").children = buttonsToAdd
        this._refocus()
        this.startAutoPlayTimer();
        Logger.processUserAction('videoResumePopup_open', this._getActionKey());
    }

    startAutoPlayTimer = () => {
        let timer = 1000;
        this.count = 0;
        if (!this.autoPlayTimerId) {
            this.autoPlayTimerId = Registry.setInterval(() => {
                if (this.count == this.autoPlayTime) {
                    Logger.processUserAction('videoResumePopup_autoPlayingOnInactivity', this._getActionKey());
                    this.$resume();
                }
                let sec = `${this.autoPlayTime - this.count}`;
                this.count++;
                /*let x=540;
                if(Number(sec)<10){
                  x=515;
                }*/
                this._updateAutoplayTimerText(sec)
            }, timer);
        }
    };

    stopAutoPlayTimer = () => {
        clearInterval(this.autoPlayTimerId);
        this.autoPlayTimerId = null;
    };

    $begin() {
        this.stopAutoPlayTimer();
        this.patch({
            visible: false
        });
        Logger.processUserAction('videoResumePopup_playFromBeginning');
        if (this.resumeType == 'video') {
            this.handleVideoResume('begin')
        } else {
            this.loadMlp('begin')
        }

        //this.fireAncestors("$handleBegin");
    }

    $resume() {
        this.stopAutoPlayTimer();
        Logger.processUserAction('videoResumePopup_playFromResumePoint');
        if (this.resumeType == 'video') {
            this.handleVideoResume('resume')
        } else {
            this.loadMlp('resume')
        }
        //this.fireAncestors("$handleResume");
    }

    $back() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp();
        Logger.processUserAction('videoResumePopup_backByUser', this._getActionKey());
        this.stopAutoPlayTimer();
        if (this.resumeType == 'video') {
            //app?.handleBackNavigation()
            Router.focusPage()
            if(this.isDeeplink) {
                app?.handleBackNavigation()
            }
        } else {
            this.loadMlp('back')
        }
    }

    override _handleKey(e: KeyboardEvent) {
        Log.info('Bookmark widget: _handleInfo ', e)
        if (this.isBookmarApiLoaded) {
            if (e.code == 'ArrowRight') {
                let len = this.tag("ButtonsWrapper.Buttons").children.length - 1;
                this._index = Math.min(len, this._index + 1);
            } else if (e.code == 'ArrowLeft') {
                this._index = Math.max(0, this._index - 1);
            }
        }
        return true
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.$back()
        return true
    }

    override _getFocused() {
        if (this.isBookmarApiLoaded) {
            return this.tag("ButtonsWrapper.Buttons").children[this._index];
        } else {
            return null
        }
    }


    /**
     * _focus is a Lightning component lifecycle method.
     * it will be triggered when the component gets focus.
     * As it is triggered via Router.focusWidget('bookmark')
     * the resume will overlay over the page and it will get focus.
     */
    override _focus() {
        this.patch({
            alpha: 1,
            item: this._vodInfo,
            visible: true,
        })
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        this._index = appApiConfig?.appConfig?.enableLikeDislike === true ? 0 : 0;
        //Resetting the initial display seting as 10 fix for XFIN-XFIN-678
        this.autoPlayTime = 10
        this.count = 0
        let sec = `${this.autoPlayTime - this.count}`;
        this._updateAutoplayTimerText(sec)
        //this.page.widgets.loadingscreen.showLoadingScreen(true)
        if(this.resumeType == 'video') {
            //this.page.widgets.loadingscreen.showLoadingScreen(false)
            //this.page.widgets.loadingscreen.showVideoLoadingScreen(true)
            this._update()
        } else {
            this.page.widgets.loadingscreen.showLoadingScreen(true)
            this._handleBookmarkData()
        }
        Log.info('Bookmark _focus')
    }

    override _unfocus() {
        this.patch({
            alpha: 0,
            visible: false,
        })
        this.page.widgets.loadingscreen.showLoadingScreen(false)
        this.page.widgets.loadingscreen.showVideoLoadingScreen(false)
        Log.info('Bookmark _unfocus')
    }

    override _onActivated(page: any) {
        this.page = page
        this._index = 1
        Log.info('Bookmark Activated')
    }

    /**
     * An async function handles the MLP loading and when loading is done
     * finds the exact Season and Episode to be played and navigate to video screen.
     * Video screen to play the exact node.
     * @async
     * @param {string} buttonType
     * @returns {*}
     */
    async loadMlp(buttonType: string) {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        if (buttonType == ('resume' || 'begin')) {
            this.page.widgets.loadingscreen.showVideoLoadingScreen(true)
        } else {
            this.page.widgets.loadingscreen.showLoadingScreen(true)
        }
        if (!this.isDeeplink) {
            await app?.bookmarkingManager.loadMlp(this._vodInfo, this._bdata[1])
            const grid = app?.navigation.getCurrentGrid()
            const vodInfo = grid?.getFocusedItem();
            if(app?.blockingManager.isItemBlocked(vodInfo)) {
                await grid?.getNextItem()
            }
        } else {
            const currGrid = app?.navigation.getCurrentGrid()!
            const _episodeVodInfo = this._bdata[1]!
            await currGrid.findAndLoadSeasonEpisode(_episodeVodInfo.season, _episodeVodInfo.episode)
        }
        if (buttonType == 'resume') {
            Router.navigate('video-screen/' + this._bdata[0]?.node_id + '_resume', false) //fix for XFIN-666 - changed from '_bookmarkresume' to 'resume'
        } else if (buttonType == 'begin') {
            Router.navigate('video-screen/' + this._bdata[0]?.node_id + '_begin', false) //fix for XFIN-666 - changed from '_bookmarkbegin' to 'begin'
        } else {
            if (this.isDeeplink) {
                const vodInfo: ItemNode = app?.navigation.getCurrentGrid().getFocusedItem();
                app?.handleBackNavigation()
            } else {
                Router.navigate(`mlp-grid-screen/${this._vodInfo.id}`, false)
            }
        }
    }


    handleVideoResume(buttonType: string) {
        if (buttonType == 'resume') {
            Router.navigate('video-screen/' + this._vodInfo?.node_id + '_resume', false)
        } else if (buttonType == 'begin') {
            Router.navigate('video-screen/' + this._vodInfo?.node_id + '_begin', false)
        }
    }

    _handleClick(target) {
        if (target && target.action) {
            this[target.action]()
        }
    }

    $handleBackButton() {
        this.$back();
    }

    $like() {
        this.handleRating(1);
    }

    $love() {
        this.handleRating(2);
    }

    $dislike() {
        this.handleRating(3);
    }

    handleRating(likeValue: number) {
        const vodInfo = this.resumeType == 'video' ? this._vodInfo : this._bdata[0];
        const listType = "node" || "list"
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const grid = app?.navigation.getCurrentGrid()
        if (!vodInfo) return;

        if (vodInfo.likedislike === likeValue) {
            likeValue = 0;
        }

        vodInfo.likedislike = likeValue;
        const itemInfo: any = this.tag('ItemInfo');
        if (itemInfo) {
            itemInfo.item = vodInfo
        }
        if (likeValue !== undefined && likeValue !== null) {
            grid?.updateItemLikeStatus(likeValue, false)
        }
        const url = postLikeDislikeUrl(vodInfo.node_id, listType, likeValue);
        let actionLabel = "Remove";
        let notificationMessage = "Rating removed!";
        if (likeValue === 1) {
            actionLabel = "Like";
            notificationMessage = "Liked!";
        } else if (likeValue === 2) {
            actionLabel = "Love";
            notificationMessage = "Loved it!";
        } else if (likeValue === 3) {
            actionLabel = "Dislike";
            notificationMessage = "Not for me!";
        }
        Logger.processUserAction('Like_Dislike_Feature_' + actionLabel, vodInfo.node_id);
        fetchData(url)
            .then((response) => {
                if (response.data.status === 1) {
                    Log.info("BookmarkWidget: Like/DislikeElemStatus: itemId, itemType, newItemVal", vodInfo.node_id, listType, likeValue);
                    Router.getActivePage()?.widgets.notification.showNotification(notificationMessage);
                }
            })
            .catch((err) => {
                Log.error("BookmarkWidget: API call failed:", err.message);
            });
    }
}
